$shm_hitalama_map_widget_float_table2 $shm_hitalama_map_widget_float_table
	contextmenu_body /
		<= Entity_schema $mol_button_minor
			title <= entity_schema_title \Создать схему сущности
			click? <=> entity_schema_open? null
		<= Csv_download $mol_button_download
			title \Скачать CSV
			blob <= csv_blob $mol_blob
			file_name <= csv_file_name \table.csv
		^
	Query_status $mol_view
		sub / <= query_status
		attr *
			^
			broken <= broken_record_notice false
	Col_name* $shm_hitalama_map_widget_float_table2_col_name
		value? <=> col_name_draft*? \
		commit? <=> col_name_commit*? null
	list_cell_id* null
	Cell_atom_link* $mol_grid_cell
		sub / <= Atom_link_content* $mol_view
			sub /
				^ atom_link_item_visible* /
					<= Atom_link_item* $mol_button_minor
						title <= cell_atom_link_label* \
						sub <= cell_atom_link_content* /
						click? <=> cell_atom_link_open*? null
						attr *
							^
							selected <= cell_atom_link_current* false
				<= Atom_link_pick* $mol_select
					value? <=> cell_atom_link*? \
					dictionary <= cell_link_options* *
					trigger_content /
						<= Atom_link_pick_icon* $mol_icon_dots_vertical
				<= Atom_link_create* $mol_button_minor
					title \Создать связанную запись
					click? <=> cell_relation_create*? null
					sub / <= Atom_link_create_icon* $mol_icon_plus
		style <= cell_style*
	Cell_list_link* $mol_grid_cell
		sub / <= List_link_content* $mol_view
			sub /
				<= List_link_pick* $mol_pick
					trigger_content /
						<= List_link_pick_icon* $mol_icon_dots_vertical
					bubble_content /
						<= List_link_options* $shm_hitalama_map_widget_float_table2_link_list
							table2 <= table_self
							cell_id <= list_cell_id*
							options <= cell_list_option_ids* /string
							value? <=> cell_list_picker_value*? /string
				<= List_link_create* $mol_button_minor
					title \Создать связанную запись
					click? <=> cell_relation_create*? null
					sub / <= List_link_create_icon* $mol_icon_plus
					attr *
						^
						selected <= cell_relation_create_current* false
				^ cell_list_item_views* /$mol_view
		style <= cell_style*
	Cell_select* $mol_grid_cell
		sub / <= Select_value* $mol_select
			value? <=> cell_select*? \
			dictionary <= cell_select_options* *
			Filter null
		style <= cell_style*
	List_link_item* $mol_button_minor
		title <= cell_list_item_label* \
		sub <= cell_list_item_content* /
		click? <=> cell_list_item_open*? null
		attr *
			^
			selected <= cell_list_item_current* false
	List_link_more* $mol_button_minor
		title \Ещё
		click? <=> cell_list_more*? null
	Relation_edit_panel* $mol_view
		sub /
			<= Relation_edit_form* $shm_hitalama_map_widget_float_table2_relation_form
				table <= table_self
				table2 <= table_self
				page_index <= relation_page_index* 0
	relation_page_index* 0
	Inverse_field_label* $mol_labeler
		title \Обратный столбец
		Content <= Inverse_field* $shm_hitalama_map_widget_float_table_select
			value? <=> inverse_field*? \
			dictionary <= inverse_field_options* *
			Filter null
	Inverse_field_name* $mol_string
		hint \Название нового обратного столбца
		value? <=> inverse_field_name*? \
	Inverse_field_create* $mol_button_minor
		title \Создать обратный столбец
		click? <=> inverse_field_create*? null
		enabled <= inverse_field_create_enabled* false

$shm_hitalama_map_widget_float_table2_relation_form $shm_hitalama_map_widget_float_table_form
	table2 null
	page_index 0

$shm_hitalama_map_widget_float_table2_col_name $shm_hitalama_map_widget_float_table_col_name

$shm_hitalama_map_widget_float_table2_link_list $shm_check_list
	table2 null
	cell_id null
	Check* $mol_check_box
		title <= check_title*
		checked? <=> checked*?
		sub <= check_content* /
